import { render } from "./CartDetails.vue?vue&type=template&id=22a6742c&scoped=true&ts=true"
import script from "./CartDetails.vue?vue&type=script&lang=ts"
export * from "./CartDetails.vue?vue&type=script&lang=ts"

import "./CartDetails.vue?vue&type=style&index=0&id=22a6742c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a6742c"]])

export default __exports__